import React from "react";
import { SnackbarKey, SnackbarProvider } from "notistack";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AppRouter from "./components/AppRouter";
import { StyledEngineProvider } from "@mui/styled-engine";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { ru } from "date-fns/locale";
import "./styles/style.scss";
import ApplicationsProvider from "./providers/ApplicationsProvider/ApplicationsProvider";

const App: React.FC = () => {
  const noticeRef: React.Ref<any> = React.createRef();
  const onClickDismiss = (key: SnackbarKey) => () => {
    noticeRef.current.closeSnackbar(key);
  };

  return (
    <StyledEngineProvider injectFirst>
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
        <ApplicationsProvider>
          <SnackbarProvider
            autoHideDuration={6000}
            maxSnack={3}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "right",
            }}
            ref={noticeRef}
            action={(key: SnackbarKey) => (
              <IconButton
                aria-label="upload picture"
                component="span"
                onClick={onClickDismiss(key)}
              >
                <CloseIcon />
              </IconButton>
            )}
          >
            <AppRouter />
          </SnackbarProvider>
        </ApplicationsProvider>
      </LocalizationProvider>
    </StyledEngineProvider>
  );
};

export default App;
